const TopHeading = ({ heading }) => {
    return (<section className="landing_banner">
        <div className="container">
            <h2 className="mt-0">{heading}</h2>
        </div>
    </section>)
}
export default TopHeading;